import { LayerSwitcher, MapGL } from '@cibo/mapgl'
import { Box } from '@mui/material'
import { FeatureCollection } from '@turf/turf'
import { InventoryMapLayers } from 'features/Inventories/components/InventoryMapLayers'
import { NavigationControl } from 'react-map-gl/dist/es5'
import { useInventoryFeatures } from '../../../../features/Inventories/queries/useInventoryFeatures'
import { InventoryGeometryLayers } from './InventoryGeometryLayers'

type BoundariesMapProps = { inventoryId: string }

export const BoundariesMap = ({ inventoryId }: BoundariesMapProps) => {
  const inventoryFC = useInventoryFeatures(inventoryId)

  return (
    <MapGL
      style={{ height: '100%', width: '100%', position: 'absolute' }}
      focusFeatures={inventoryFC.data as FeatureCollection}
    >
      <InventoryMapLayers />
      <InventoryGeometryLayers inventoryId={inventoryId} />
      <NavigationControl showZoom position="bottom-right" />
      <Box style={{ position: 'absolute', bottom: 35, left: 8 }}>
        <LayerSwitcher />
      </Box>
    </MapGL>
  )
}
